<template>
  <div class="workOrderTask">
    <TaskItem 
        v-for="item in taskList" 
        :key="item.t"
        :type="UPLOAD_TYPE.MATERIAL"
        :UPLOAD_TYPE="UPLOAD_TYPE"
        :taskData="item"
    />
    <TaskItem 
        v-for="item in workTaskList" 
        :key="item.t"
        :type="UPLOAD_TYPE.ORDER"
        :UPLOAD_TYPE="UPLOAD_TYPE"
        :taskData="item"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TaskItem from './taskItem.vue'
const UPLOAD_TYPE  = Object.freeze({
    MATERIAL: 1,//素材
    ORDER: 2,//工单
}) 
export default {
    name: 'WorkOrderTask',
    components: {
        TaskItem
    },
    data() {
        return {
            UPLOAD_TYPE
        }
    },
    computed: {
        ...mapState('workOrder',[
            'taskList',
            'workTaskList'
        ]),
        hasData() {
            return !!(this.taskList.length + this.workTaskList.length)
        }
    },
    methods: {
        _beforeunload(event) {
            // Cancel the event as stated by the standard.
            event.preventDefault();
            // Chrome requires returnValue to be set.
            event.returnValue = "刷新/关闭该页面将会终止上传任务，是否继续";
        }
    },
    watch: {
        hasData: {
            handler(n) {
                window.removeEventListener('beforeunload', this._beforeunload);
                if (n) {
                    window.addEventListener("beforeunload", this._beforeunload)
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.workOrderTask {
    position: fixed;
    bottom: 10px;
    right: 20px;
    z-index: 1000;
    width: 360px;
    max-height: 100vh;
    overflow: auto;
}
</style>